import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import router from './router'
import store from './store'

import imgUrl from './base/img' //引入整理好的圖片路徑

Vue.use(VueLazyload)

Vue.config.productionTip = false

Vue.prototype.$imgUrl = imgUrl  //需在原型增加屬性，不寫這行直接在下方傳入好像不行

new Vue({
  router,
  store,
  // imgUrl,
  render: h => h(App)
}).$mount('#app')
